import { render, staticRenderFns } from "./myCoupon.vue?vue&type=template&id=737ef438&scoped=true&"
import script from "./myCoupon.vue?vue&type=script&lang=js&"
export * from "./myCoupon.vue?vue&type=script&lang=js&"
import style0 from "./myCoupon.vue?vue&type=style&index=0&id=737ef438&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737ef438",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('737ef438')) {
      api.createRecord('737ef438', component.options)
    } else {
      api.reload('737ef438', component.options)
    }
    module.hot.accept("./myCoupon.vue?vue&type=template&id=737ef438&scoped=true&", function () {
      api.rerender('737ef438', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/personalCenter/myCoupon.vue"
export default component.exports